/**
 * MiseOne Skeleton (Prompt 16B).
 *
 * Use to maintain layout while data loads. Replaces "Loading..." text.
 */
export function Skeleton({ className = "", testId }) {
    return (
        <div
            data-testid={testId}
            className={`animate-pulse bg-neutral-200/70 rounded-md ${className}`}
        />
    );
}

export function SkeletonCard({ rows = 3 }) {
    return (
        <div className="kop-card p-5 space-y-3" data-testid="skeleton-card">
            <Skeleton className="h-4 w-1/3" />
            {Array.from({ length: rows }).map((_, i) => (
                <Skeleton key={i} className="h-3 w-full" />
            ))}
        </div>
    );
}

export function SkeletonRow({ cols = 4 }) {
    return (
        <tr className="border-t border-neutral-100" data-testid="skeleton-row">
            {Array.from({ length: cols }).map((_, i) => (
                <td key={i} className="px-5 py-3">
                    <Skeleton className="h-3 w-full" />
                </td>
            ))}
        </tr>
    );
}
